// extracted by mini-css-extract-plugin
module.exports = {"headingContainer":"_3CcnYCRtghIzV4mQ1rFTsD","headingText":"_3i50wgqZyENCizQamslZjC","venueFilter":"e0RJYxxVHxgi6zHMJr1hL"};